import React from 'react';
import { GetServerSideProps } from 'next';
import cookie from 'next-cookies';
import CenteredContainer from '@/common/CenteredContainer';
import GiftCardsPage from '@/shared/pages/gift-cards';

import initializePage, { isIndexProps } from '../app/common/pageSetup';
import { YUM_TOKEN_COOKIE_KEY } from '@/configuration/constants';

type GiftCardPageProps = {
  yumToken: string;
}

const GiftCardPage = ({ yumToken }: GiftCardPageProps): JSX.Element => (
    <>
      <CenteredContainer>
        <GiftCardsPage yumToken={yumToken} />
      </CenteredContainer>
    </>
  );

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const response = await initializePage(ctx, 'gift-cards');
  if (isIndexProps(response)) {
    const yumAccessToken = cookie(ctx)[YUM_TOKEN_COOKIE_KEY] ?? null;
    return {
      props: {
        yumToken: yumAccessToken,
        ...response.props
      }
    };
  }
  return response;
};

export default GiftCardPage;
